import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/tokens.css'
import './styles/global.css'

const host = document.getElementById('root')
if (!host) throw new Error('No #root in index.html')

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
